import { DialogContent } from "@mui/material";
import { lazy } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import WorkFlowDetails from "./WorkFlowDetails";

const WorkflowMasterDialog = lazy(() => import("./WorkflowMasterDialog"));
const dialogsTypesWise: any = {
    "workflowMasterCreate": () => <WorkflowMasterDialog pageType={'create'} />,
    "EditWorkFlowMaster": () => <WorkflowMasterDialog pageType={'edit'} />,
    'WorkflowDetails': () => <WorkFlowDetails />
}

const dialogTypeFullScreen: any = {
    "workflowMasterCreate": () => <WorkflowMasterDialog pageType={'create'} />,
    "EditWorkFlowMaster": () => <WorkflowMasterDialog pageType={'edit'} />,
    'WorkflowDetails': () => <WorkFlowDetails />
}


const WorkflowMasterDialogComponent: React.FC = () => {
    const { type, isFullScreen,} = useSelector((state: RootState) => state.dialog);

    return (
        <>
            {
                (isFullScreen && dialogTypeFullScreen[type]?.()) ?
                    (
                        <DialogContent sx={{ height: "100%", margin: 0, padding: 0 }}  > {dialogTypeFullScreen[type]?.() ?? null} </DialogContent>
                    ) : (
                        <>
                            {dialogsTypesWise[type]?.() ?? null}
                        </>
                    )
            }
        </>
    )
}
export default WorkflowMasterDialogComponent


